module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWBAMAAAAoU0G7AAAAJFBMVEVHcEx7e3t6enp6enp6enp6enp6enp7e3t6enp6enp6enp6enq41xBfAAAAC3RSTlMAYbZsi5YkU+vZw0jwdZEAAACPSURBVBjTlY4xDoJAEEWHoNhiYucRtqGzoNGaxp6G2srE0iNwBHt7F4iQdzl3dl2w9VXz8jN/RkSpelkw9k+55CrJU+esfansx8ZJAoWxKeQa1XTGlgx+Zw3tCOfQUOMYvnUrlWMsryA8dyt85IL0IHTx65IgWfMjHpXY6S4InLaeHciDmUnui7xlM0fT9QPiEUphK4Pw9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/download-icon.png
// module id = TH8f
// module chunks = 1